
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class AppMenuNavItem extends Vue {
    @Prop(Boolean) readonly collapsed: boolean | undefined;
    @Prop([String, Array]) readonly icon: string | [] | undefined;
    @Prop(String) readonly label: string | undefined;
    @Prop() readonly url: string | object | undefined;
}

